var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAudience(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM17.7424 17.7052C18.0806 17.5968 18.3826 17.5 18.7812 17.5C21.0938 17.5 23 19.4062 23 21.7188V22.5C23 23.3438 22.3125 24 21.5 24H10.5C9.65625 24 9 23.3438 9 22.5V21.7188C9 19.4062 10.875 17.5 13.1875 17.5C13.5838 17.5 13.8846 17.5956 14.2229 17.7033C14.6583 17.8417 15.156 18 16 18C16.8226 18 17.3119 17.8432 17.7424 17.7052ZM10.5 21.7188V22.5H21.5V21.7188C21.5 20.2188 20.2812 19 18.7812 19C18.6164 19 18.4207 19.0618 18.1669 19.142C17.6988 19.2898 17.0333 19.5 16 19.5C14.9428 19.5 14.2692 19.2884 13.7984 19.1405C13.5456 19.061 13.3513 19 13.1875 19C11.6875 19 10.5 20.2188 10.5 21.7188ZM20.5 12.5C20.5 15 18.4688 17 16 17C13.5 17 11.5 15 11.5 12.5C11.5 10.0312 13.5 8 16 8C18.4688 8 20.5 10.0312 20.5 12.5ZM19 12.5C19 10.875 17.625 9.5 16 9.5C14.3438 9.5 13 10.875 13 12.5C13 14.1562 14.3438 15.5 16 15.5C17.625 15.5 19 14.1562 19 12.5Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAudience);
export default __webpack_public_path__ + "static/media/img_audience.5d38ee6021fecba8f548d64a7e3dcc3e.svg";
export { ForwardRef as ReactComponent };